import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IrisIconComponent, IconSizes } from '@sondermind/iris/icon';

interface BannerMetric {
  icon: string;
  label: SafeHtml;
}

@Component({
  selector: 'landing-page-banner',
  standalone: true,
  imports: [
    CommonModule,
    IrisIconComponent
  ],
  templateUrl: './landing-page-banner.component.html',
  styleUrls: ['./landing-page-banner.component.scss']
})
export class LandingPageBannerComponent {
  readonly iconSizes = IconSizes;

  constructor(private domSanitizer: DomSanitizer) {}

  readonly metrics: BannerMetric[] = [
    {
      icon: 'verified_user_outline',
      label: this.domSanitizer.bypassSecurityTrustHtml('Accepts hundreds of insurances')
    },
    {
      icon: 'acute_outline',
      label: this.domSanitizer.bypassSecurityTrustHtml('Start care in <strong>2 days</strong>')
    },
    {
      icon: 'dollar',
      label: this.domSanitizer.bypassSecurityTrustHtml('<strong>$25</strong> average copay')
    }
  ];
}
